import {
  Bolt,
  CircleQuestionMark,
  Globe,
  LayoutDashboard,
  LogOut,
  Menu,
} from "lucide-react";
import React, { useState, useRef } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { Nav } from "react-bootstrap";
import styles from "../../_css/Header.module.css";
import { deleteAuthToken } from "../../utils/helper";
import { HEADER } from "../../data/commonComponents";
import { useSelector, useDispatch } from "react-redux";
import LanguageSwitcher, { LanguageSwitcher2 } from "./LanguageSwitcher";
import { resetPage } from "../../_store/reducers/pageChangeReducer";

const Header = ({ ispublic = false }) => {
  const [activeIcon, setActiveIcon] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);

  const langRef = useRef(null);

  const navigate = useNavigate();
  const location = useLocation();
  const pathname = location.pathname;
  const dispatch = useDispatch();
  const lang = useSelector((state) => state.language.lang);
  const { helpAndSupport, accountSettings, logout, dashboard, language } =
    HEADER[lang];

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const handleNavClick = (path) => {
    navigate(path);
    setMenuOpen(false);
  };

  const handleLogout = () => {
    
    dispatch(resetPage());
    deleteAuthToken();
    window.location.reload();
  };

  const handleAccountSettings = () => {
    navigate("/account-settings");
    setMenuOpen(false);
  };

  if (ispublic) {
    return (
      <Nav
      className={`${styles["header-nav"]} navbar justify-content-between d-flex`}
    >
      <NavLink
        style={{ flex: 1 }}
        // to="/"
        onClick={(e) => {
          e.preventDefault();
          dispatch(resetPage());
          navigate("/");
        }}
        className={`nav-link ${styles.askSlahLogo}`}
      >
        <i>
          <img
            src={`${process.env.REACT_APP_PROJECT_URL}/img/askSalah.png`}
            alt="logo"
            style={{ width: "4rem" }}
            // className={styles["header-logo"]}
          />
        </i>
      </NavLink>

      <NavLink
        style={{ flex: 1 }}
        onClick={(e) => {
          e.preventDefault();
          window.open("http://sal125.smartsway.com/", "_blank");
        }}
        className="nav-link text-center"
      >
        <i>
          <img
            src={`${process.env.REACT_APP_PROJECT_URL}/img/sal125.png`}
            alt="logo"
            style={{ width: "5.7rem" }}
            // className={styles["header-logo"]}
          />
        </i>
      </NavLink>

      {/* Desktop Navigation */}
      <div
        style={{ flex: 1, padding: "0 1rem" }}
        className={`${styles.desktopNav} justify-content-end text-end`}
      >
        <ul
          style={{ listStyle: "none", color: "#6B7280" }}
          className="d-flex align-items-end gap-3 m-0"
        >
         
          <li>
            <LanguageSwitcher2 />
          </li>
        </ul>
      </div>

      {/* Mobile Hamburger Menu */}
      <div
        style={{ flex: 1, padding: "0 1rem" }}
        className={  lang === 'ar' ? `${styles.mobileNav} text-start` : `${styles.mobileNav} text-end`}
        
      >
        <button
          className={styles.hamburger}
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <Menu size={24} />
        </button>

        <div
          className={`${styles.dropdownMenu} ${
            menuOpen ? styles.dropdownMenuOpen : ""
          }`}
          style={{ pointerEvents: menuOpen ? "auto" : "none" }}
        >
          <ul style={{ listStyle: "none", color: "#6B7280" }}>
            
            <li>
              <div
                className={`${styles["nav-icon"]} pe-cursor p-0 d-flex align-items-center gap-2`}
              >
                {/* Wrap LanguageSwitcher2 */}
                <div ref={langRef} onClick={() => setMenuOpen(false)}>
                  <LanguageSwitcher2 />
                </div>

                {/* Clicking span simulates click on first child inside wrapper */}
                <span onClick={() => (langRef.current.firstChild.click(), setMenuOpen(false))}>
                  {language}
                </span>
              </div>
            </li>
          </ul>
        </div>
      </div>

      {/* <div className="d-flex align-items-center gap-2">
        <UserCircle2Icon
          size={34}
          className="pe-cursor my-3 rounded-full"
        />
        <DropdownProfile userName = "Kamal Upadhyay" />
      </div> */}
      {/* {!isPendingUser && location.pathname.includes("offer-management") && (
        <NavLink
          to="/offer-management"
          className="nav-link"
          activeclassname={styles.active}
          onClick={(event) => event.preventDefault()}
        >
          <OverlayTrigger placement="right" overlay={tooltipOfferManagement}>
            <i>
              <Fan alt="Offer Management" className={styles.icon} />
            </i>
          </OverlayTrigger>
        </NavLink>
      )} */}
      {/* <NavLink
        to="/logout"
        className={`nav-link ${styles["bottom-0"]}`}
        onClick={(e) => e.preventDefault()}
        activeclassname={styles.active}
      >
        <SignOutButton />
        <img src={logoutIcon} alt="Logout" className={styles.icon} />
      </NavLink> */}
    </Nav>
    );
  }

  return (
    <Nav
      className={`${styles["header-nav"]} navbar justify-content-between d-flex`}
    >
      <NavLink
        style={{ flex: 1 }}
        // to="/"
        onClick={(e) => {
          e.preventDefault();
          dispatch(resetPage());
          navigate("/");
        }}
        className={`nav-link ${styles.askSlahLogo}`}
      >
        <i>
          <img
            src={`${process.env.REACT_APP_PROJECT_URL}/img/askSalah.png`}
            alt="logo"
            style={{ width: "4rem" }}
            // className={styles["header-logo"]}
          />
        </i>
      </NavLink>

      <NavLink
        style={{ flex: 1 }}
        onClick={(e) => {
          e.preventDefault();
          window.open("http://sal125.smartsway.com/", "_blank");
        }}
        className="nav-link text-center"
      >
        <i>
          <img
            src={`${process.env.REACT_APP_PROJECT_URL}/img/sal125.png`}
            alt="logo"
            style={{ width: "5.7rem" }}
            // className={styles["header-logo"]}
          />
        </i>
      </NavLink>

      {/* Desktop Navigation */}
      <div
        style={{ flex: 1, padding: "0 1rem" }}
        className={`${styles.desktopNav} justify-content-end text-end`}
      >
        <ul
          style={{ listStyle: "none", color: "#6B7280" }}
          className="d-flex align-items-end gap-3 m-0"
        >
          <li>
            <i
              onClick={() => {
                navigate("/help-and-support");
              }}
              className={`${styles["nav-icon"]} pe-cursor${
                pathname === "/help-and-support" ? " " + styles["active"] : ""
              }`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-message-circle-question-mark-icon lucide-message-circle-question-mark"
              >
                <path d="M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719" />
                <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
                <path d="M12 17h.01" />
              </svg>
            </i>
          </li>
          <li>
            <i
              onClick={handleAccountSettings}
              className={`${styles["nav-icon"]} pe-cursor${
                pathname === "/account-settings" ? " " + styles["active"] : ""
              }`}
            >
              <Bolt size={18} />
            </i>
          </li>
          <li>
            <i
              onClick={handleLogout}
              className={`${styles["nav-icon"]} pe-cursor${
                pathname === "/logout" ? " " + styles["active"] : ""
              }`}
            >
              <LogOut size={18} />
            </i>
          </li>
          <li>
            <i
              onClick={(e) => {
                e.preventDefault();
                dispatch(resetPage());
                navigate("/");
              }}
              className={`${styles["nav-icon"]} pe-cursor${
                pathname === "/" ? " " + styles["active"] : ""
              }`}
            >
              <LayoutDashboard size={18} />
            </i>
          </li>
          <li>
            <LanguageSwitcher2 />
          </li>
        </ul>
      </div>

      {/* Mobile Hamburger Menu */}
      <div
        style={{ flex: 1, padding: "0 1rem" }}
        className={  lang === 'ar' ? `${styles.mobileNav} text-start` : `${styles.mobileNav} text-end`}
        
      >
        <button
          className={styles.hamburger}
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <Menu size={24} />
        </button>

        <div
          className={`${styles.dropdownMenu} ${
            menuOpen ? styles.dropdownMenuOpen : ""
          }`}
          style={{ pointerEvents: menuOpen ? "auto" : "none" }}
        >
          <ul style={{ listStyle: "none", color: "#6B7280" }}>
            <li onClick={() => handleNavClick("/help-and-support")}>
              <div className="d-flex align-items-center gap-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719" />
                  <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
                  <path d="M12 17h.01" />
                </svg>
                {helpAndSupport}
              </div>
            </li>
            <li onClick={handleAccountSettings}>
              <div className="d-flex align-items-center gap-2">
                <Bolt size={18} />
                {accountSettings}
              </div>
            </li>
            <li onClick={handleLogout}>
              <div className="d-flex align-items-center gap-2">
                <LogOut size={18} />
                {logout}
              </div>
            </li>
            <li onClick={() => (handleNavClick("/"),dispatch(resetPage()))}>
              <div className="d-flex align-items-center gap-2">
                <LayoutDashboard size={18} />
                {dashboard}
              </div>
            </li>
            <li>
              <div
                className={`${styles["nav-icon"]} pe-cursor p-0 d-flex align-items-center gap-2`}
              >
                {/* Wrap LanguageSwitcher2 */}
                <div ref={langRef} onClick={() => setMenuOpen(false)}>
                  <LanguageSwitcher2 />
                </div>

                {/* Clicking span simulates click on first child inside wrapper */}
                <span onClick={() => (langRef.current.firstChild.click(), setMenuOpen(false))}>
                  {language}
                </span>
              </div>
            </li>
          </ul>
        </div>
      </div>

      {/* <div className="d-flex align-items-center gap-2">
        <UserCircle2Icon
          size={34}
          className="pe-cursor my-3 rounded-full"
        />
        <DropdownProfile userName = "Kamal Upadhyay" />
      </div> */}
      {/* {!isPendingUser && location.pathname.includes("offer-management") && (
        <NavLink
          to="/offer-management"
          className="nav-link"
          activeclassname={styles.active}
          onClick={(event) => event.preventDefault()}
        >
          <OverlayTrigger placement="right" overlay={tooltipOfferManagement}>
            <i>
              <Fan alt="Offer Management" className={styles.icon} />
            </i>
          </OverlayTrigger>
        </NavLink>
      )} */}
      {/* <NavLink
        to="/logout"
        className={`nav-link ${styles["bottom-0"]}`}
        onClick={(e) => e.preventDefault()}
        activeclassname={styles.active}
      >
        <SignOutButton />
        <img src={logoutIcon} alt="Logout" className={styles.icon} />
      </NavLink> */}
    </Nav>
  );
};

export default Header;
